
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11210",
                "data-name": "矩形 11210",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(0.166)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_250",
        "data-name": "蒙版组 250",
        "class": "cls-2",
        "transform": "translate(-0.166)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "chuanghu",
            "class": "cls-3",
            "d": "M119.9,103.15a1.026,1.026,0,0,0-1.05-1.05h-15.9a1.026,1.026,0,0,0-1.05,1.05v15.9a1.026,1.026,0,0,0,1.05,1.05h15.9a1.026,1.026,0,0,0,1.05-1.05v-15.9Zm-1-.048v4h-16v-4Zm-16,5h5v11h-5Zm6,11v-11h10v11Zm0,0",
            "transform": "translate(-98.9 -99.1)"
          }
        }
      ]
    }
  ]
})
    }
  